export const CUISINE_OPTIONS = [
  'Italian', 'Mexican', 'Japanese', 'Chinese', 'Thai', 'Indian',
  'American', 'Mediterranean', 'Korean', 'Vietnamese', 'French', 'Middle Eastern',
] as const;

export const DIETARY_OPTIONS = [
  'Vegetarian', 'Vegan', 'Gluten-Free', 'Dairy-Free', 'Nut-Free', 'Halal', 'Kosher',
] as const;
